import { Fragment } from 'react'
import { Menu, Transition } from '@headlessui/react'
import { EllipsisHorizontalIcon } from '@heroicons/react/20/solid'
import {adminUserService} from "../../../services/admin/admin.customer.service";
import {loadUsers, useUsersDispatch} from "../../../context/UsersContext";
import { CopyToClipboard } from "react-copy-to-clipboard/src";

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export default function ManageUserDropdownMenu({cell}) {
    const usersDispatch = useUsersDispatch();


    const handleUnbindHwidClick = async e => {
        const licenceId = cell.row.original.licence.id;
        await adminUserService.unbindHwid(licenceId);
        await loadUsers(usersDispatch);
    }

    const handleUnbindDiscordClick = async e => {
        const userId = cell.row.original.id;
        await adminUserService.unbindDiscord(userId);
        loadUsers(usersDispatch);
    }



    return (
        <Menu as="div" className="relative inline-block text-left">
            <div>
                <Menu.Button className="justify-center">
                    <EllipsisHorizontalIcon className="-mr-1 ml-2 h-5 w-5" aria-hidden="true" />
                </Menu.Button>
            </div>

            <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
            >
                <Menu.Items className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-[#27272A] shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                    <div className="py-1">
                        <Menu.Item>
                            {({ active }) => (
                                <a
                                    href="#"
                                    onClick={handleUnbindHwidClick}
                                    className={classNames(
                                        active ? 'bg-gray-500 dark:text-white text-sm !text-opacity-70' : 'dark:text-white text-sm !text-opacity-70',
                                        'block px-4 py-2 text-sm'
                                    )}
                                >
                                    Unbind Hardware ID
                                </a>
                            )}
                        </Menu.Item>
                        <Menu.Item>
                            {({ active }) => (
                                <a
                                    onClick={handleUnbindDiscordClick}
                                    href="#"
                                    className={classNames(
                                        active ? 'bg-gray-500 dark:text-white text-sm !text-opacity-70' : 'dark:text-white text-sm !text-opacity-70',
                                        'block px-4 py-2 text-sm'
                                    )}
                                >
                                    Unbind Discord
                                </a>
                            )}
                        </Menu.Item>
                    </div>
                </Menu.Items>
            </Transition>
        </Menu>
    )
}